import { render, staticRenderFns } from "./AddStudio.vue?vue&type=template&id=4bee8e2e&scoped=true&"
import script from "./AddStudio.vue?vue&type=script&lang=js&"
export * from "./AddStudio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bee8e2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tommy/Documents/BrocheBallet/studio-manager/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bee8e2e')) {
      api.createRecord('4bee8e2e', component.options)
    } else {
      api.reload('4bee8e2e', component.options)
    }
    module.hot.accept("./AddStudio.vue?vue&type=template&id=4bee8e2e&scoped=true&", function () {
      api.rerender('4bee8e2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/studios/AddStudio.vue"
export default component.exports